<template>
    <div class="pageInfo">
        <el-form :inline="true" :model="form" ref="formData" v-loading="loading"
                 label-width="120px">
            <el-form-item label="所属部门">
                <el-input style="width:200px" v-model="form.departmentNameBill" readonly></el-input>
            </el-form-item>
            <el-form-item label="运维申请单号">
                <el-input style="width:200px" v-model="form.relaBillNo" readonly></el-input>
            </el-form-item>
            <el-form-item label="申请日期">
                <el-input style="width:200px" v-model="form.relaBillDate" readonly></el-input>
            </el-form-item>

            <el-form-item label="项目名称">
                <el-input style="width:200px" v-model="form.projectName" readonly></el-input>
            </el-form-item>
            <el-form-item label="申请人">
                <el-input style="width:200px" v-model="form.applyBy" readonly></el-input>
            </el-form-item>
            <el-form-item label="申请部门">
                <el-input style="width:200px" v-model="form.departmentName" readonly></el-input>
            </el-form-item>


            <el-form-item label="服务类型">
                <el-input style="width:200px" v-model="form.serviceType" ></el-input>
            </el-form-item>
            <el-form-item label="紧急程度">
                <el-input style="width:200px" v-model="form.urgencyType" ></el-input>
            </el-form-item>
            <el-form-item label="客户">
                <el-input style="width:200px" v-model="form.customerName" ></el-input>
            </el-form-item>
            
            <el-form-item label="服务地点">
                <el-input style="width:200px" v-model="form.serviceAddress" ></el-input>
            </el-form-item>
            <el-form-item label="受理确认" >
                <el-radio v-model="form.acceptanceKind" label="1">同意受理</el-radio>
                <el-radio v-model="form.acceptanceKind" label="0">拒绝受理</el-radio>
            </el-form-item>
            <el-form-item label="派工负责人" >
                <el-input style="width:200px" v-model="form.dispatchBy" ></el-input>
            </el-form-item>
            
            <el-form-item label="派工部门" >
                <el-input style="width:200px" v-model="form.departmentNameDispatch" ></el-input>
            </el-form-item>
            <el-form-item label="派工日期" >
                <el-input style="width:200px" v-model="form.departmentNameDispatch" ></el-input>
            </el-form-item>

            <el-form-item label="派工内容">
                <el-input style="width:860px"
                        type="textarea"
                        v-model="form.dispatchContent"
                        rows="2">
                </el-input>
            </el-form-item>

            <el-form-item label="备注">
                <el-input style="width:860px"
                        type="textarea"
                        v-model="form.remark"
                        rows="2">
                </el-input>
            </el-form-item>
        </el-form>

    </div>
</template>

<script>
    export default {
        name: "InfoPage",
        props: ['formData', 'loading'],
        components: {},
        data() {
            return {
                dialoading: this.loading,
                form: JSON.parse(JSON.stringify(this.formData)),
                dialogVisible: true,
                formLabelWidth: '80px',

            };
        },
        mounted() {
            //
        },
        methods: {

            headerStyle() {
                return "text-align:center;height:35px;line-height:35px;padding: 5px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle() {
                return "text-align:center"
            },
        }
    }
</script>

